import { defineStore } from 'pinia';
import { useEventStore } from './eventStore';
import { computed, ref, watch } from 'vue';
import type { ParticipantId } from '@/utilities/typealiases';

/**
 * This should contain all the data for the entire Sprint/Cup and the layout should just grab the data from here.
 * TODO: Need to refacotor SprintHeatLayout to use this store instead of the event store directly
 * NOTE! For now we only have the ranking of each heat here, so we can share it.
 */
export const useSprintStore = defineStore('sprintstore', () => {
    const eventStore = useEventStore();

    /**
     * We keep the ranking for the prologue here, so we can use it in both the heat layout and the sprint layout, this is a map of participant id to rank in the prologue
     */
    const prologueRanking = ref<Map<ParticipantId, number>>(new Map());

    /**
     * This will trigger every time the eventID changes so we set up the loaders again
     */
    // watch(
    //     () => eventStore.eventID,
    //     async (nv, ov) => {},
    //     { immediate: true },
    // );

    /**
     * Sets the ranking for a participant in the prologue.
     * @param {ParticipantId} participantId
     * @param {number} ranking
     * @remarks This is only a temporary solution until we can move all the Sprint calculations here.
     */
    const setPrologueRanking = (rankings: Map<ParticipantId, number>) => {
        prologueRanking.value = rankings;
    };

    return {
        /**
         * Sets the ranking for a participant in the prologue.
         * @param {ParticipantId} participantId
         * @param {number} ranking
         */
        SetPrologueRanking: setPrologueRanking,

        /**
         * Gets the ranking for all the participants in the prologue, this is a map of participant id to rank in the prologue
         * @returns {Map<ParticipantId, number>} the ranking for all the participants in the prologue
         */
        PrologueRanking: computed(() => prologueRanking.value),
    };
});
